import { Export } from '@custom-types/Export';
import { Response } from '@custom-types/Response';
import apiFn from '@services/api-service';

const api = (eventId: string) =>
  apiFn(`/api/uapi/events/${eventId}/checkin`, {
    Accept: 'application/vnd.eventmobi+json; version=p.9',
  });

export const createBadgeExport = (
  eventId: string,
  params: { checkin_code: string } | { test: true }
) =>
  api(eventId)
    .post('print-labels', params)
    .then((response: Response<Export>) => response.data);

export const getBadgeExport = (eventId: string, exportId: string) =>
  api(eventId)
    .get(`print/${exportId}`)
    .then((response: Response<Export>) => response.data);
